import { Injectable } from "@angular/core";
import { BaseIcons, ThemeSwitchService } from "@indusoft/angular-base";
import { Subject, takeUntil } from "rxjs";

import { AuthViewGlossary } from "../../auth/app/glossary/auth-view-glossary";

@Injectable()

export class ThemeStore {
    private _isDarkTheme: boolean = false;
    private _logoSrc: string;

    private unsubscribe$: Subject<boolean> = new Subject();
    private boundHandleMessage: (event: MessageEvent) => void;

    constructor(
        private themeService: ThemeSwitchService,
    ) {
        if (this.isInIframe()) {
            window.parent.postMessage(
                { action: "getTheme" },
                document.referrer
            );
            this.boundHandleMessage = this.handleMessage.bind(this);
            window.addEventListener("message", this.boundHandleMessage);
        }
        this.themeService.getSelectedThemeSubscription()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(theme => {
                this._isDarkTheme = theme === ThemeSwitchService.darkTheme;
                this._logoSrc = theme === ThemeSwitchService.darkTheme
                    ? AuthViewGlossary.DARK_THEME_LOGO_SRC
                    : AuthViewGlossary.LIGHT_THEME_LOGO_SRC;
            });
    }

    public destroy(): void {
        window.removeEventListener("message", this.boundHandleMessage);
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    public isInIframe() {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    }

    public switchTheme() {
        if (this.isDarkTheme)
            this.themeService.setSelectedTheme(ThemeSwitchService.lightTheme);
        else
            this.themeService.setSelectedTheme(ThemeSwitchService.darkTheme);
    }

    public get isDarkTheme(): boolean {
        return this._isDarkTheme;
    }

    public get tooltipThemeButton(): string {
        return this.isDarkTheme === true
            ? AuthViewGlossary.DARK_THEME
            : AuthViewGlossary.LIGHT_THEME;
    }

    public get iconThemeButton(): string {
        return this.isDarkTheme ? BaseIcons.lightTheme : BaseIcons.darkTheme;
    }

    public get logoSrc(): string {
        return this._logoSrc;
    }

    public get baseIcons(): BaseIcons {
        return BaseIcons;
    }

    private handleMessage(event: MessageEvent): void {
        this.themeService.setSelectedTheme(ThemeSwitchService[event.data.theme]);
    }
}